'use strict'

var defaultFont = { // eslint-disable-line
  name: '',
  family: '',
  type: ''
}

export const FONT_FAMILY = {}
export const FONT_FAMILY_TYPES = {
  'sans-serif': 'Helvetica, Arial, sans-serif, --system-default',
  serif: 'Times New Roman, Georgia, serif, --system-default',
  monospace: 'Courier New, monospace, --system-default'
}
export const FONT_FACE = {}
